import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import XHR from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18next
  .use(XHR)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: (item: any) => {
        // if (item[0] === 'zh-CN') {
        //   return `/locales/zh.json`;
        // }
        return `/locales/en.json`;
      },
    },
    react: {
      useSuspense: true,
    },
    fallbackLng: 'en',
    preload: ['en'],
    keySeparator: false,
    interpolation: { escapeValue: false },
    debug: true,
  });

export default i18next;
export const t = i18next.t.bind(i18next);
